import { Input } from 'antd';
import 'antd/es/input/style/index';
import './index.less';

export default Input;
